import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useContext } from 'preact/compat';
import { FitnessFormOptionsCTX } from '@membershipForm/context/Options';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import { useFormContext } from 'react-hook-form';
import useDidMount from 'beautiful-react-hooks/useDidMount';
import { Header, IndividualMemberForm, SubHeader, Wrapper, } from './styles';
function MemberForm(props) {
    const { formComplete, formRef, members, } = props;
    const { memberModalTitle, loggedIn } = useContext(FitnessFormOptionsCTX);
    const { handleSubmit, setValue } = useFormContext();
    const loginAction = () => {
        formRef?.current?.submit();
    };
    const handleMount = useCallback(() => {
        members.forEach(({ name }, idx) => {
            setValue(`members.${idx}.type`, name);
        });
    }, [members]);
    useDidMount(handleMount);
    return (_jsxs(Wrapper, { className: "form", children: [_jsx(Header, { children: memberModalTitle }), members.map(({ name, label }, idx) => (_jsxs(IndividualMemberForm, { children: [_jsx(SubHeader, { children: label }), _jsx("input", { type: "hidden", name: `member-${idx}-type`, value: name }), _jsx(TextInput, { inputAttrs: {
                            id: `member-${idx}-firstname`,
                            name: `members.${idx}.firstName`,
                            type: 'string',
                        }, labelAttrs: {
                            htmlFor: `member-${idx}-firstname`,
                            text: 'Name',
                            isFieldRequired: true,
                        } }), _jsx(TextInput, { inputAttrs: {
                            id: `member-${idx}-lastname`,
                            name: `members.${idx}.lastName`,
                            type: 'string',
                        }, labelAttrs: {
                            htmlFor: `member-${idx}-lastName`,
                            text: 'Surname',
                            isFieldRequired: true,
                        } })] }))), _jsx("button", { type: "button", onClick: () => {
                    if (!loggedIn) {
                        window.dispatchEvent(new CustomEvent('login.open'));
                        window.dispatchEvent(new CustomEvent('login.action', {
                            detail: loginAction,
                        }));
                    }
                    else {
                        loginAction();
                    }
                }, className: "btn btn--primary btn--full", disabled: !formComplete, children: "Proceed to Checkout" })] }));
}
export default MemberForm;
